<template>
  <div>
    <div>
      <div>
        <div v-if="type=='textarea'">
          <textarea v-model="value" :placeholder="`${payload.modal_title} ...`" class="full_width" rows="15"></textarea>
        </div>
        <div v-if="type=='radio-group'">
          <BaseRadioGroup
            v-model="value"
            name="demo"
            :options="payload.options"
            groupClass="display_inline_block min_width_138_px"
            inputClass=""
            labelClass="margin-left"
            class="is-flex is-flex-wrap-wrap is-justify-content-flex-start"
            vertical
          />
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import BaseRadioGroup from '@/components/BaseRadioGroup'

export default {
  name: 'company-texts-form',
  components: {
    BaseRadioGroup
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      value: null,
      type: 'textarea'
    }
  },
  created () {
    this.type = this.payload.type || this.type
    this.value = this.payload.textValue || ''
  },
  methods: {
    submit () {
      const resource_id = `${this.payload.data.resource_type.toLowerCase()}_id`
      this.$network_utils[this.payload.request]({ [resource_id]: this.payload.data.resource_id, [this.payload.value]: this.value }).then(() => {
        this.$utils.emit('show_toast', { text: 'success' })
        this.payload.afterAction(this.value)
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
